<template>
  <div class="mt-28 order-lg-3 mt-md-12" v-if="getActions?.length > 0">
    <div class="fw-medium d-md-none">Товар участвует в акциях</div>

    <div class="scroll-slider mx-md-n16 px-md-16">
      <div
        class="grid-row grid-row_sm d-flex_wrap d-flex_sm-nowrap grid-row_sm-xs"
      >
        <div v-for="item in getActions" :key="item.id" class="grid-col pt-8">
          <Action
            :title="item.name"
            :text="item.text"
            :id="item.id"
            :picture="item.picture"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";
import Action from "@/pages/product_card/components/Action/Action.vue";

export default {
  name: "ActionWrap",
  components: { Action },
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  computed: {
    ...mapState(useProductStore, ["getActions"]),
  },
};
</script>
